import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from './applicationinfraestructure/services/authentication.service';
import { environment } from '../environments/environment';
import { UsersData } from './applicationinfraestructure/interfaces/userData';
import { MsalUserService } from './applicationinfraestructure/services/msaluser.service';
@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private router: Router,
    private authService: AuthenticationService,
    private msalService: MsalUserService,
    private userData: UsersData) {
  }
  user: UsersData;
  errorMessage: any;
  ngOnInit() {
   this.authService.getUsuario(environment.userEmailLogged).subscribe(
      values => {
        //debugger;
        this.userData = values;
        environment.edificiosAutorizados =  values.edificiosAutorizados;
        environment.marcasAutorizadas =  values.marcasAutorizadas;
        environment.tipoUsuario =  values.tipoUsuario;
        environment.userSubscripciónId = values.subscripciónId;
      },
      (error) => {
        //alert('El usuario logueado ' + environment.userEmailLogged + ' no tiene acceso a la aplicación.');
      //this.msalService.logout();
      }
    );

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });
  }
}
